// import { Company } from "@/api/models/company"

// export interface GeneralInfoProps {
//   currentCompany: Company | null
//   setCurrentCompany: React.Dispatch<React.SetStateAction<Company | null>>
// }

export const integration = [
  {
    label: 'Контур',
    value: 'kontur',
  },
  {
    label: 'Айтиком',
    value: 'itcom',
  },
]
